export enum DYNAMIC_FORM_FIELD_TYPE {
    TEXT = 'text',
    NUMBER = 'number',
    SELECT = 'select',
    SELECT_TREE = 'select-tree',
}

export enum DYNAMIC_FORM_FIELD_VALIDATOR_TYPE {
    REQUIRED = 'required',
    MIN = 'min',
    MAX = 'max',
    CUSTOM = 'custom',
}
